import React from 'react';
import { Paper, Typography, TextField } from '@mui/material';

const AbsentNotesCard = ({ absentNotes, onFieldChange }) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 3,
        backgroundColor: 'white',
        fontFamily: 'Lato, sans-serif',
      }}
    >
      <Typography
        variant='h6'
        sx={{ mb: 2, color: '#9291f0', fontWeight: 600 }}
      >
        Additional Context About Absence
      </Typography>
      <TextField
        label='Additional Context About Absence'
        multiline
        minRows={4}
        fullWidth
        value={absentNotes || ''}
        onChange={(event) => onFieldChange('absentNotes', event.target.value)}
        placeholder='Add additional context about the absence'
        variant='outlined'
      />
    </Paper>
  );
};

export default AbsentNotesCard;
